"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var DepositReqDetailExpander_1 = require("./expander/DepositReqDetailExpander");
var routes_1 = require("../../../../../shared/includes/routes");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableActionCopy_1 = require("../../../../../../shared/components/table_actions/TableActionCopy");
var FinanceDepositList = /** @class */ (function (_super) {
    __extends(FinanceDepositList, _super);
    function FinanceDepositList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchLoginInput = null;
        _this.searchOuterIdInput = null;
        _this.searchGwsIdInput = null;
        _this.LOGIN_FILTER = "FinanceDepositList-LoginFilter";
        _this.EMAIL_FILTER = "FinanceDepositList-EmailFilter";
        _this.TRANSACTION_FILTER = "FinanceDepositList-TransactionFilter";
        _this.GATEWAY_FILTER = "FinanceDepositList-GatewayFilter";
        return _this;
    }
    FinanceDepositList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    FinanceDepositList.prototype.doDetectUIType = function () {
        if (this.props.state.getServerDocument(routes_1.routes.page_finance_deposits_list)) {
            if (this.props.state.getServerDocument(routes_1.routes.page_finance_deposits_list).view == "VIEW_DEP_SUPPORT") {
                this.setState({ ViewKind: "DEPMANAGER", complete_only: false });
            }
        }
    };
    FinanceDepositList.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.LOGIN_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.EMAIL_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.TRANSACTION_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.GATEWAY_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.GATEWAY_FILTER);
        }
        this.setState({
            searchLoginFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).selectedValues,
            searchLoginValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).filterValue,
            isSearchLogin: this.props.state.getUIFilter().getUIFilterItemByKey(this.LOGIN_FILTER).isFilterActive,
            searchEmailFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).selectedValues,
            searchEmailValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).filterValue,
            isSearchEmail: this.props.state.getUIFilter().getUIFilterItemByKey(this.EMAIL_FILTER).isFilterActive,
            searchOuterIdFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).selectedValues,
            searchOuterIdValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).filterValue,
            isSearchOuterId: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).isFilterActive,
            searchGwsIdFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.GATEWAY_FILTER).selectedValues,
            searchGwsIdValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.GATEWAY_FILTER).filterValue,
            isSearchGwsId: this.props.state.getUIFilter().getUIFilterItemByKey(this.GATEWAY_FILTER).isFilterActive,
            ViewKind: "STANDART"
        }, function () {
            _this.doDetectUIType();
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                deposit_status_filter: data.deposit_status_filter,
                deposit_type_filter: data.deposit_type_filter
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.doDetectUIType();
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            deposit_status_filter: [],
            deposit_type_filter: [],
            searchEmailFilter: [],
            searchEmailValue: "",
            searchLoginFilter: [],
            searchLoginValue: "",
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            searchGwsIdFilter: [],
            searchGwsIdValue: "",
            complete_only: true,
            isSearchEmail: false,
            isSearchLogin: false,
            isSearchOuterId: false,
            isSearchGwsId: false
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    //public 
    FinanceDepositList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceDepositList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    FinanceDepositList.prototype.loadData = function (Props, onDone) {
        if (this.state.ViewKind == "DEPMANAGER") {
            Props.data.LoadRangeDataByBrandsListEx({
                brands: this.props.brandsList,
                allBrands: this.props.allBrands,
                Limit: this.state.pageSize,
                Offset: this.getDataOffset(),
                from_year: this.state.dtFrom.get('year'),
                from_month: this.state.dtFrom.get('month') + 1,
                from_day: this.state.dtFrom.get('date'),
                from_hour: this.state.dtFrom.get('hour'),
                from_minute: this.state.dtFrom.get('minute'),
                to_year: this.state.dtTo.get('year'),
                to_month: this.state.dtTo.get('month') + 1,
                to_day: this.state.dtTo.get('date'),
                to_hour: this.state.dtTo.get('hour'),
                to_minute: this.state.dtTo.get('minute'),
                complete_only: this.state.complete_only,
                allMoneyflowTypes: this.props.allDepositTypes,
                moneyflow_types: this.props.depositTypesList,
                is_filter_email_part: this.state.isSearchEmail,
                email_part: this.state.searchEmailValue,
                is_filter_login_part: this.state.isSearchLogin,
                login_part: this.state.searchLoginValue,
                is_filter_transaction_part: this.state.isSearchOuterId,
                transaction_part: this.state.searchOuterIdValue,
                is_filter_gws_transaction_part: this.state.isSearchGwsId,
                gws_transaction_part: this.state.searchGwsIdValue
            }, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
        else {
            Props.data.LoadRangeDataByBrandsList({
                brands: this.props.brandsList,
                allBrands: this.props.allBrands,
                Limit: this.state.pageSize,
                Offset: this.getDataOffset(),
                from_year: this.state.dtFrom.get('year'),
                from_month: this.state.dtFrom.get('month') + 1,
                from_day: this.state.dtFrom.get('date'),
                from_hour: this.state.dtFrom.get('hour'),
                from_minute: this.state.dtFrom.get('minute'),
                to_year: this.state.dtTo.get('year'),
                to_month: this.state.dtTo.get('month') + 1,
                to_day: this.state.dtTo.get('date'),
                to_hour: this.state.dtTo.get('hour'),
                to_minute: this.state.dtTo.get('minute'),
                complete_only: this.state.complete_only,
                allMoneyflowTypes: this.props.allDepositTypes,
                moneyflow_types: this.props.depositTypesList,
                is_filter_email_part: this.state.isSearchEmail,
                email_part: this.state.searchEmailValue,
                is_filter_login_part: this.state.isSearchLogin,
                login_part: this.state.searchLoginValue,
                is_filter_transaction_part: this.state.isSearchOuterId,
                transaction_part: this.state.searchOuterIdValue
            }, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
    };
    FinanceDepositList.prototype.onClearEmailFilter = function () {
        var _this = this;
        this.setState({
            searchEmailFilter: [],
            searchEmailValue: "",
            isSearchEmail: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onChangeEmailFilter = function (e) {
        var _this = this;
        this.setState({ searchEmailValue: e.target.value }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.EMAIL_FILTER, _this.state.searchEmailValue);
        });
    };
    FinanceDepositList.prototype.onConfirmEmailFilter = function () {
        var _this = this;
        this.setState({
            searchEmailFilter: [this.state.searchEmailValue],
            isSearchEmail: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.EMAIL_FILTER, [_this.state.searchEmailValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.EMAIL_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onClearLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [],
            searchLoginValue: "",
            isSearchLogin: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onChangeLoginFilter = function (e) {
        var _this = this;
        this.setState({ searchLoginValue: e.target.value }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.LOGIN_FILTER, _this.state.searchLoginValue);
        });
    };
    FinanceDepositList.prototype.onConfirmLoginFilter = function () {
        var _this = this;
        this.setState({
            searchLoginFilter: [this.state.searchLoginValue],
            isSearchLogin: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.LOGIN_FILTER, [_this.state.searchLoginValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.LOGIN_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onClearOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            isSearchOuterId: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TRANSACTION_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TRANSACTION_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TRANSACTION_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onChangeOuterIdFilter = function (e) {
        var _this = this;
        this.setState({ searchOuterIdValue: e.target.value }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TRANSACTION_FILTER, _this.state.searchOuterIdValue);
        });
    };
    FinanceDepositList.prototype.onConfirmOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [this.state.searchOuterIdValue],
            isSearchOuterId: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TRANSACTION_FILTER, [_this.state.searchOuterIdValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TRANSACTION_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onClearGwsIdFilter = function () {
        var _this = this;
        this.setState({
            searchGwsIdFilter: [],
            searchGwsIdValue: "",
            isSearchGwsId: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.GATEWAY_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.GATEWAY_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.GATEWAY_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.onChangeGwsIdFilter = function (e) {
        var _this = this;
        this.setState({ searchGwsIdValue: e.target.value }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.GATEWAY_FILTER, _this.state.searchGwsIdValue);
        });
    };
    FinanceDepositList.prototype.onConfirmGwsIdFilter = function () {
        var _this = this;
        this.setState({
            searchGwsIdFilter: [this.state.searchGwsIdValue],
            isSearchGwsId: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.GATEWAY_FILTER, [_this.state.searchGwsIdValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.GATEWAY_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    FinanceDepositList.prototype.minifyText = function (longText) {
        var _ret = longText;
        if (_ret.length > 20) {
            var _start = _ret.substring(0, 9);
            var _end = _ret.substring(_ret.length - 10);
            _ret = _start + "..." + _end;
        }
        return _ret;
    };
    FinanceDepositList.prototype.getDepManagerColumns = function () {
        var _this = this;
        var _email_filter = this.state.searchEmailFilter;
        var _login_filter = this.state.searchLoginFilter;
        var _outerid_filter = this.state.searchOuterIdFilter;
        var _gwsid_filter = this.state.searchGwsIdFilter;
        return [{
                title: 'Дата',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 150
            }, {
                title: 'Логин',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                }
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_player_email,
                key: this.props.data.dk_player_email,
                width: 180,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u043E\u0447\u0442\u0435", value: _this.state.searchEmailValue, onChange: _this.onChangeEmailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEmailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEmailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEmailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Транзакция',
                dataIndex: this.props.data.dk_outer_transaction_id,
                key: this.props.data.dk_outer_transaction_id,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchOuterIdInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438", value: _this.state.searchOuterIdValue, onChange: _this.onChangeOuterIdFilter.bind(_this), onPressEnter: function () { _this.onConfirmOuterIdFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmOuterIdFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearOuterIdFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _outerid_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.outer_transaction_id.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchOuterIdInput.focus();
                        });
                    }
                }, render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(TableActionCopy_1.default, { hint: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430", onClick: function () { _this.onCopyLinkClick(record); } }),
                        "  ",
                        _this.minifyText(record.outer_transaction_id)));
                }
            }, {
                title: 'Транзакция шлюза',
                dataIndex: this.props.data.dk_dt_gws_tx_id,
                key: this.props.data.dk_dt_gws_tx_id,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchGwsIdInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0448\u043B\u044E\u0437\u0430", value: _this.state.searchGwsIdValue, onChange: _this.onChangeGwsIdFilter.bind(_this), onPressEnter: function () { _this.onConfirmGwsIdFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmGwsIdFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearGwsIdFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _gwsid_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.dt_gws_tx_id.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchGwsIdInput.focus();
                        });
                    }
                }, render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(TableActionCopy_1.default, { hint: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430", onClick: function () { _this.onCopyLinkGwsClick(record); } }),
                        "  ",
                        _this.minifyText(record.dt_gws_tx_id)));
                }
            }, {
                title: 'Провайдер',
                dataIndex: this.props.data.dk_raw_gws_title,
                key: this.props.data.dk_raw_gws_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.raw_gws_title,
                        "/",
                        record.raw_prv_title));
                },
            }, {
                title: 'Сумма',
                dataIndex: this.props.data.dk_amount_in_deposit_currency_without_comission,
                key: this.props.data.dk_amount_in_deposit_currency_without_comission,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency_without_comission),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Статус',
                dataIndex: this.props.data.dk_deposit_state_title,
                key: this.props.data.dk_deposit_state_title,
                render: function (text, record, idx) {
                    if (record.deposit_state_complete) {
                        return (React.createElement("div", { style: { color: "#008000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    if (record.deposit_state_error) {
                        return (React.createElement("div", { style: { color: "#FF0000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    return (React.createElement("div", null, record.deposit_state_title));
                },
                width: 150,
                filters: this.state.deposit_status_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.deposit_state_title.includes(value); },
            }, {
                title: 'Бонус',
                dataIndex: this.props.data.dk_active_bonus_id,
                key: this.props.data.dk_active_bonus_id,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.active_bonus_title));
                }
            }];
    };
    FinanceDepositList.prototype.onCopyLinkGwsClick = function (record) {
        var el = document.createElement('textarea');
        el.value = "" + record.dt_gws_tx_id;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u0448\u043B\u044E\u0437\u0430 \u0431\u044B\u043B\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"));
    };
    FinanceDepositList.prototype.onCopyLinkClick = function (record) {
        var el = document.createElement('textarea');
        el.value = "" + record.outer_transaction_id;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u0448\u043B\u044E\u0437\u0430 \u0431\u044B\u043B\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"));
    };
    FinanceDepositList.prototype.getAdminColumns = function () {
        var _this = this;
        var _email_filter = this.state.searchEmailFilter;
        var _login_filter = this.state.searchLoginFilter;
        var _outerid_filter = this.state.searchOuterIdFilter;
        return [{
                title: 'Дата',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 150
            }, {
                title: 'Игрок',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchLoginInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchLoginValue, onChange: _this.onChangeLoginFilter.bind(_this), onPressEnter: function () { _this.onConfirmLoginFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmLoginFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearLoginFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _login_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchLoginInput.focus();
                        });
                    }
                },
                render: function (text, record, idx) {
                    if (record.player_locked) {
                        return (React.createElement("div", { style: { color: "#FF0000", textDecoration: "line-through" } }, record.player_login));
                    }
                    else {
                        return (React.createElement("div", null, record.player_login));
                    }
                }
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_player_email,
                key: this.props.data.dk_player_email,
                width: 180,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u043E\u0447\u0442\u0435", value: _this.state.searchEmailValue, onChange: _this.onChangeEmailFilter.bind(_this), onPressEnter: function () { _this.onConfirmEmailFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmEmailFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearEmailFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _email_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Транзакция',
                dataIndex: this.props.data.dk_outer_transaction_id,
                key: this.props.data.dk_outer_transaction_id,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchOuterIdInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438", value: _this.state.searchOuterIdValue, onChange: _this.onChangeOuterIdFilter.bind(_this), onPressEnter: function () { _this.onConfirmOuterIdFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmOuterIdFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearOuterIdFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _outerid_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.outer_transaction_id.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchOuterIdInput.focus();
                        });
                    }
                }
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_deposit_type_title,
                key: this.props.data.dk_deposit_type_title,
                width: 150,
                filters: this.state.deposit_type_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.deposit_type_title.includes(value); },
            }, {
                title: 'Провайдер',
                dataIndex: this.props.data.dk_raw_gws_title,
                key: this.props.data.dk_raw_gws_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.raw_gws_title,
                        "/",
                        record.raw_prv_title));
                },
            }, {
                title: 'Сумма',
                dataIndex: this.props.data.dk_amount_in_deposit_currency_without_comission,
                key: this.props.data.dk_amount_in_deposit_currency_without_comission,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency_without_comission),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Промокод',
                dataIndex: this.props.data.dk_promo_code_code,
                key: this.props.data.dk_promo_code_code,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.promo_code_code));
                }
            }, {
                title: 'Бонус',
                dataIndex: this.props.data.dk_active_bonus_id,
                key: this.props.data.dk_active_bonus_id,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.active_bonus_title));
                }
            }, {
                title: 'Статус',
                dataIndex: this.props.data.dk_deposit_state_title,
                key: this.props.data.dk_deposit_state_title,
                render: function (text, record, idx) {
                    if (record.deposit_state_complete) {
                        return (React.createElement("div", { style: { color: "#008000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    if (record.deposit_state_error) {
                        return (React.createElement("div", { style: { color: "#FF0000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    return (React.createElement("div", null, record.deposit_state_title));
                },
                width: 150,
                filters: this.state.deposit_status_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.deposit_state_title.includes(value); },
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }];
    };
    FinanceDepositList.prototype.getColumns = function () {
        if (this.state.ViewKind == "DEPMANAGER") {
            return this.getDepManagerColumns();
        }
        else {
            return this.getAdminColumns();
        }
    };
    FinanceDepositList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    FinanceDepositList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    FinanceDepositList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FinanceDepositList.prototype.onDepositTypeFilterChanged = function (allDepositTypes, DepositTypeCode, Action) {
        if (this.props.onDepositTypeFilterChanged) {
            this.props.onDepositTypeFilterChanged(allDepositTypes, DepositTypeCode, Action);
        }
    };
    FinanceDepositList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    FinanceDepositList.prototype.onCheckBoxChecked = function (checked) {
        this.setState({ complete_only: checked });
    };
    FinanceDepositList.prototype.getToolbarRenderObject = function () {
        if (this.state.ViewKind == "DEPMANAGER") {
            return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })));
        }
        else {
            return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement("div", { style: { display: "flex", flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
                    React.createElement("div", { style: { marginLeft: "2px", marginRight: "2px" } }, "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435"),
                    React.createElement(antd_1.Switch, { checked: this.state.complete_only, onChange: this.onCheckBoxChecked.bind(this) })),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды: ", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allDepositTypes, availBrands: this.props.availDepositTypes, captions: { checkbox: "Все типы пополнений: ", placeholder: "Выберите тип пополнения" }, selectedBrands: this.props.depositTypesList, onBrandFilterChanged: this.onDepositTypeFilterChanged.bind(this) })));
        }
    };
    FinanceDepositList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.getToolbarRenderObject(),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement(DepositReqDetailExpander_1.default, { data: record, state: _this.props.state, viewType: _this.state.ViewKind }));
                }, scroll: { x: true } })));
    };
    return FinanceDepositList;
}(React.Component));
exports.default = FinanceDepositList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_deposits_list/ui/component/FinanceDepositList.tsx
// module id = 1989
// module chunks = 0